import React from "react"
import { IPayGroup } from "../../models"
import { SelectField, MenuItem } from "material-ui"
import strings from "../../localization/strings"
import AccountStore from "../../stores/AccountStore"

interface IProps {
    width?: number
    allowNonSelect?: boolean
    payGroups: IPayGroup[]
    selectedPayGroup: IPayGroup
    handleSelect(selectedPayGroup: IPayGroup): void
}

const PayGroupSelector: React.SFC<IProps> = (props: IProps) => {
    return props.payGroups && props.payGroups.length === 1 ?
        <div style={{ position: "relative", paddingTop: 18, paddingBottom: 5, marginTop: 20, width: props.width || 256 }}>
            <span style={{ position: "absolute", top: -5, color: "rgba(0, 0, 0, 0.3)", fontSize: 12 }}>
                {strings.Pay_Groups}
            </span>
            <div style={{ color: "rgb(97, 97, 97)", fontSize: 16 }}>
                {props.selectedPayGroup.Name}
            </div>
            <hr style={{ borderBottom: "1px solid rgb(224, 224, 224)", borderTop: "none", marginTop: 5 }} />
        </div> :
        <SelectField
            data-intercom-target={"Payroll-Select-PayGroup"}
            floatingLabelText={strings.Pay_Groups}
            style={{ width: props.width || 256 }}
            value={props.selectedPayGroup ? props.selectedPayGroup : AccountStore.NonSelectItemValue}
            onChange={(event, key, payload) => {
                localStorage.setItem("findd_selected_paygroup_id", payload === AccountStore.NonSelectItemValue ? AccountStore.NonSelectItemValue : payload.Id)
                props.handleSelect(payload === AccountStore.NonSelectItemValue ? null : payload)
            }}
            title={props.selectedPayGroup ? props.selectedPayGroup.Name : strings.All}
        >
            {props.allowNonSelect &&
                <MenuItem
                    value={AccountStore.NonSelectItemValue}
                    primaryText={strings.All}
                />
            }
            {props.payGroups.map((payGroup, key) =>
                <MenuItem
                    key={key}
                    value={payGroup}
                    primaryText={payGroup.Name}
                />
            )}
        </SelectField>
}

export default PayGroupSelector